{
  "$id": "module://termination-rules",
  "$schema": "wealthlane://schemas/domain",
  "title": "Termination Rules",
  "description": "Termination Rules field catalog for plan-level termination rule configuration",
  "type": "object",
  "properties": {
    "participantTerminationTypeId": {
      "type": "string",
      "title": "Termination Type",
      "widget": "hidden"
    },
    "terminationTypeName": {
      "type": "string",
      "title": "Termination Type",
      "widget": "label",
      "adapterProps": {
        "hideLabel": true,
        "variant": "body-s"
      }
    },
    "terminationRuleSetId": {
      "type": "string",
      "title": "Termination Rule Set ID",
      "widget": "hidden"
    },
    "expirationInMonths": {
      "type": "string",
      "title": "Months",
      "widget": "text",
      "charset": "digits"
    },
    "expirationInDays": {
      "type": "string",
      "title": "Days",
      "widget": "text",
      "charset": "digits"
    },
    "cancelShareTypeId": {
      "type": "string",
      "title": "Cancel share type",
      "widget": "select",
      "actionId": "FETCH_CANCEL_SHARE_TYPES"
    },
    "awardAdjustmentMethodId": {
      "type": "string",
      "title": "Acceleration method",
      "widget": "select",
      "actionId": "FETCH_AWARD_ADJUSTMENT_METHODS"
    }
  }
}
